import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSubscription } from "../../context/SubscriptionContext";
import { Card } from "../common/Card";
import { Button } from "../common/Button";
import { ProgressBar } from "../common/ProgressBar";
import { UpgradeModal } from "./UpgradeModal";
import styles from "./HiveLimitBanner.module.css";

/** Shows "3/3 hives used" for Free-tier users, with an upgrade CTA. Renders
 * nothing for paid tiers (no limit to warn about). */
export function HiveLimitBanner() {
  const { isFree, hiveLimit, activeHiveCount, atHiveLimit } = useSubscription();
  const { t } = useTranslation();
  const [showUpgrade, setShowUpgrade] = useState(false);

  if (!isFree || !hiveLimit) return null;

  return (
    <Card className={[styles.card, atHiveLimit ? styles.atLimit : ""].join(" ")}>
      <div className={styles.row}>
        <div className={styles.text}>
          <strong>{t("dashboard.hiveLimitWarning", { count: activeHiveCount, limit: hiveLimit })}</strong>
          <ProgressBar value={activeHiveCount} max={hiveLimit} tone={atHiveLimit ? "danger" : "honey"} />
        </div>
        <Button size="sm" onClick={() => setShowUpgrade(true)}>Upgrade</Button>
      </div>
      <UpgradeModal open={showUpgrade} onClose={() => setShowUpgrade(false)} />
    </Card>
  );
}
